import { useEffect, useState } from 'react';
import Home from './components/Home';
import Lobby from './components/Lobby';
import Tournament from './components/Tournament';
import AnonUpgradeBadge from './components/AnonUpgradeBadge';
import { subscribeToTournament } from './services/firestore';
import { usePlayerIdentity } from './hooks/usePlayerIdentity';
import './theme.css';

function App() {
  const [me, setMe] = usePlayerIdentity();
  const [tournament, setTournament] = useState(undefined);
  const [connectionError, setConnectionError] = useState('');

  useEffect(() => {
    if (!me) {
      setTournament(undefined);
      return;
    }
    return subscribeToTournament(me.tournamentId, setTournament, (err) => {
      console.error(err);
      setConnectionError(
        'Could not connect to Firebase. Check that src/firebase.js (or .env.local) has your real project config.'
      );
    });
  }, [me]);

  // The stored player identity points at a tournament that no longer exists
  // (e.g. it was deleted, or this is stale state from a previous session).
  // Drop it so the player lands back on Home instead of loading forever.
  useEffect(() => {
    if (tournament === null) {
      setMe(null);
    }
  }, [tournament, setMe]);

  let content;
  if (!me) {
    content = <Home setMe={setMe} connectionError={connectionError} />;
  } else if (!tournament) {
    content = <div className="page-loading">Loading...</div>;
  } else if (tournament.status !== 'lobby') {
    content = <Tournament me={me} setMe={setMe} tournament={tournament} connectionError={connectionError} />;
  } else {
    content = <Lobby me={me} setMe={setMe} tournament={tournament} connectionError={connectionError} />;
  }

  // Mounted alongside every screen (not inside any of them) so the
  // save-progress/sign-in escape hatch stays available regardless of which
  // screen a guest is on — see useAnonymousUpgradePrompt for why this can't
  // just live inside AppHeader's per-screen slots.
  return (
    <>
      {content}
      <AnonUpgradeBadge />
    </>
  );
}

export default App;
